import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import Markdown from "react-markdown";
import classNames from "classnames";
import { makeStyles } from "@material-ui/styles";
import { AppContext } from "../Context";
import Views from "./views";

const query = gql`
  query home {
    suggestions {
      id
      at
      duration
      maxParticipants
      maxQueueSlots
      activity {
        id
        name
        infoText
        color
        tags
        location {
          id
          name
        }
        price {
          inclVat
          priceLevelId
          priceLevelName
        }
      }
      resourceAssignments {
        resource {
          id
          name
        }
        role
      }
      canReserve {
        reserve
        enqueue
        reason
        persons
      }
      freeSlots
      queue
    }
    upcoming {
      id
      at
      duration
      maxParticipants
      maxQueueSlots
      activity {
        id
        name
        infoText
        color
        tags
        location {
          id
          name
        }
        price {
          inclVat
          priceLevelId
          priceLevelName
        }
        resourceAssignments {
          resource {
            id
            name
          }
          role
        }
      }
      resourceAssignments {
        resource {
          id
          name
        }
        role
      }
      canReserve {
        reserve
        enqueue
        reason
        persons
      }
      freeSlots
      queue
    }
    upcomingCourses {
      id
      isFull
      totalBooked
      totalEnqueued
      placesLeft
      placesLeftInQueue
      firstOccasion
      lastOccasion
      canReserve {
        reserve
        enqueue
        reason
        persons
      }
      maxParticipants
      maxQueueSlots
      activity {
        id
        name
        infoText
        tags
        color
        resourceAssignments {
          resource {
            name
          }
          role
        }
        location {
          id
          name
        }
        price {
          inclVat
          priceLevelId
          priceLevelName
        }
        occasions {
          id
          at
          duration
        }
      }
      resourceAssignments {
        resource {
          id
          name
        }
        role
      }
      canReserve {
        reserve
        enqueue
        reason
        persons
      }
      placesLeft
      placesLeftInQueue
    }
    manages {
      id
      name
      email
      civicRegistrationNumber
      photo
    }
  }
`;

const useStyles = makeStyles((theme) => ({
  container: {
    display: "block",
    overflow: "auto",
    "@media (max-width: 667px)": {
      overflowY: "scroll",
      "-webkit-overflow-scrolling": "touch",
    },
  },
  content: {
    width: "100%",
    height: "100%",
    background: theme.app.background[0],
    color: theme.app.color,
    display: "grid",
    gridTemplateColumns: "1fr",
    position: "relative",
    transition: "all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms",
    "@media (max-width: 1024px)": {
      padding: 0,
    },
  },
  landingText: {
    margin: "0 auto",
    width: "77%",
    padding: "2rem 0 1rem 0",
    "& h2": {
      fontSize: "1.5rem !important",
    },
    "@media screen and (max-width: 1024px)": {
      width: "100%",
      padding: "2rem 1rem 1rem 1rem",
    },
  },
}));

const Home = (props) => {
  const classes = useStyles();
  const { state } = useContext(AppContext);
  const { landingText, headerText } = state;
  const auth = useSelector(
    (state) => state.oidc.user !== null && !state.oidc.user.expired
  );

  const { loading, error, data, refetch } = useQuery(query, {
    pollInterval: 60000,
  });
  if (error) return <h1>{error.message}</h1>;
  if (loading) return <div>loading</div>;
  const { suggestions, upcoming, manages, upcomingCourses, whoami } = data;
  const anyUpcoming = upcoming && upcoming.length > 0;
  const anySuggestions = suggestions && suggestions.length > 0;
  const anyCourses = upcomingCourses && upcomingCourses.length > 0;
  if (!anyUpcoming && auth) {
    window.setTimeout(() => refetch(), 500);
  }
  return (
    <main className={classes.container}>
      <div className={classNames(classes.content, "home__content-container")}>
        <Markdown
          source={headerText}
          escapeHtml={false}
          skipHtml={false}
          className="header-text-container"
        />
        <section>
          {auth && (
            <Markdown
              source={landingText}
              escapeHtml={false}
              skipHtml={false}
              className={classes.landingText}
            />
          )}

          <Views
            anySuggestions={anySuggestions}
            anyCourses={anyCourses}
            anyUpcoming={anyUpcoming}
            suggestions={suggestions}
            upcoming={upcoming}
            upcomingCourses={upcomingCourses}
            manages={manages}
            loading={loading}
            whoami={whoami}
          />
        </section>
      </div>
    </main>
  );
};

export default Home;
